import axios from 'axios'

const state = {
	user: null,
	embedToken: null,
	platformUrl: null,
	fileStorageDomain: null
}

const getters = {}

const actions = {
	auth({ commit, state }) {
		return new Promise((resolve, reject) => {
			axios
				.post('auth', { token: state.embedToken })
				.then(res => {
					const token = res.data.jwt
					localStorage.setItem('rental-system-token', token)
					axios.defaults.headers.common = {
						Authorization: 'Bearer ' + token
					}
					commit('SET_FILE_STORAGE_DOMAIN', res.data.fileStorageDomain)
					resolve()
				})
				.catch(reject)
		})
	}
}

const mutations = {
	SET_EMBED_TOKEN(state, value) {
		state.embedToken = value
	},
	SET_FILE_STORAGE_DOMAIN(state, value) {
		state.fileStorageDomain = value
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
